"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _ApartmentAddCustomerModal = _interopRequireDefault(require("./ApartmentAddCustomerModal.vue"));
var _CustomerItem = _interopRequireDefault(require("./CustomerItem.vue"));
var ApartmentCustomer = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(ApartmentCustomer, _Vue);
  var _super = (0, _createSuper2.default)(ApartmentCustomer);
  function ApartmentCustomer() {
    var _this;
    (0, _classCallCheck2.default)(this, ApartmentCustomer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "customer", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildingId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "apartmentId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    return _this;
  }
  (0, _createClass2.default)(ApartmentCustomer, [{
    key: "onSubmitOk",
    value: function onSubmitOk(data) {
      return data;
    }
  }, {
    key: "handleAdd",
    value: function handleAdd() {
      this.$refs.ApartmentAddCustomerModal.handleOpen(this.customer);
    }
  }, {
    key: "created",
    value: function created() {}
  }]);
  return ApartmentCustomer;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ApartmentCustomer.prototype, "customer", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ApartmentCustomer.prototype, "buildingId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ApartmentCustomer.prototype, "apartmentId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Emit)("submit:ok")], ApartmentCustomer.prototype, "onSubmitOk", null);
ApartmentCustomer = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ApartmentAddCustomerModal: _ApartmentAddCustomerModal.default,
    CustomerItem: _CustomerItem.default
  }
})], ApartmentCustomer);
var _default = ApartmentCustomer;
exports.default = _default;